import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const InterviewScheduleCard = ({ interview }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate('/application-tracking');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
          <Image 
            src={interview?.companyLogo} 
            alt={interview?.companyLogoAlt}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground truncate mb-1">
            {interview?.jobTitle}
          </h4>
          <p className="text-xs text-muted-foreground truncate">{interview?.company}</p>
        </div>
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Calendar" size={16} className="text-primary" />
          <span>{interview?.date}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Clock" size={16} className="text-primary" />
          <span>{interview?.time}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Video" size={16} className="text-primary" />
          <span>{interview?.mode}</span>
        </div>
      </div>
      <Button 
        variant="outline" 
        size="sm" 
        fullWidth
        onClick={handleViewDetails}
      >
        View Details
      </Button>
    </div>
  );
};

export default InterviewScheduleCard;